/**
 * Genera un ID único para uso interno del builder de correos.
 * No es un UUID formal, pero es suficiente para distinguir filas
 * y módulos dentro de una misma sesión.
 *
 * @returns {number}
 */
export const generateId = () => Date.now() + Math.random();
